import * as React from 'react';
import { Terminal } from '@bloomberg/media-ui-icons';

import { useSlug } from '../hooks/useSlug';
import type { GlobalProps } from '../types';
import { classes } from '../utils';
import { TranslatedMessage } from '../utils/translate-messages';

import styles from './TerminalTout.module.css';

const TERMINAL_INFO_PAGE = {
  en: 'https://www.bloomberg.com/professional/solution/bloomberg-terminal-learn-more/?utm_source=bbg&utm_medium=intpro&utm_campaign=trmnl&utm_content=web_dotcom&tactic=794999',
  ja: 'https://about.bloomberg.co.jp/solution/bloomberg-terminal/',
};

export type TerminalToutProps = {
  centerAligned?: boolean;
  languageCode?: keyof typeof TERMINAL_INFO_PAGE;
} & GlobalProps;

export const TerminalTout = React.forwardRef<
  HTMLAnchorElement,
  TerminalToutProps
>(function TerminalToutComponent(props: TerminalToutProps, ref) {
  const { languageCode, name = 'TerminalTout', centerAligned = false } = props;
  const terminalLink = TERMINAL_INFO_PAGE[languageCode ?? 'en'];

  const [componentName] = useSlug(name);

  return (
    <a
      href={terminalLink}
      target="_blank"
      rel="noreferrer"
      className={classes(
        [styles.terminalTout, centerAligned && styles.centerAligned],
        props
      )}
      ref={ref}
      data-component={componentName}
    >
      <div className={styles.background}>
        <div className={styles.info}>
          <TranslatedMessage
            id="media-ui-core_beforeItsHereItsOnTheBloombergTerminal"
            defaultMessage="Before it’s here, it’s on the <span>Bloomberg Terminal</span>"
            values={{
              span: (chunks) => (
                <span className={styles.highlight}>{chunks}</span>
              ),
            }}
          />
        </div>
        <div className={styles.cta}>
          <Terminal className={styles.icon} />{' '}
          <TranslatedMessage
            id="media-ui-core_learnMore"
            defaultMessage="LEARN MORE"
          />
        </div>
      </div>
    </a>
  );
});
